<template>      
  <div class="wrapper">
    <div class="container">
      <md-card class="customCard navbar-margin">
        <md-card-content>
          <div class="md-layout">
            <div class="md-layout-item">
              <div class="tim-typo">
                <h2 class="title">Vertriebspartner in Ihrer Nähe</h2> 
                <p>Die Beratung und der Verkauf von Balkon &amp; Zaun-Profi Leibhammer + Rietz GmbH Produkten erfolgt über unsere Vertriebspartner.<br> 
                  Bei Interesse an unseren Produkten, sowie zur persönlichen Beratung nehmen Sie bitte Kontakt zu einem unserer Vertriebspartner in Ihrer Nähe auf.</p>
              </div>
              <div class="grid-container">
                <div class="container" v-for="partner in partners" :key="partner.id">
                  <md-card class="partnerCard z-depth-1">
                    <md-card-content>
                      <h5 style="font-weight: bold;"><span class="material-icons contactIcon">place</span>{{partner.address1}}</h5> 
                      <p>{{partner.title}}</p>
                      <p v-if="partner.address2 !== null">{{partner.address2}}</p>
                      <p>{{partner.name}}</p>
                      <p v-if="partner.phone !== null"><span class="material-icons contactIcon">phone</span>{{partner.phone}}</p>
                      <p v-if="partner.fax !== null"><span class="material-icons contactIcon">print</span>{{partner.fax}}</p>
                      <p v-if="partner.mail !== null"><span class="material-icons contactIcon">mail_outline</span>{{partner.mail}}</p>
                    </md-card-content>
                  </md-card>
                </div>
              </div>
            </div>
          </div>
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>

<script>
import partners from '@/components/partners.json';

export default {
  name: 'Vertriebspartner',
  props: {
    msg: String
  },
  data() {
    return {
      partners
    }
  },
  methods: {
    onResponsiveInverted() {
      if (window.innerWidth < 600) {
        this.responsive = true;
      } else {
        this.responsive = false;
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->